module.exports = __webpack_public_path__ + "li.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/li.svg
// module id = 659
// module chunks = 0